import { Play } from 'lucide-react';
import { cn } from '../../lib/utils.js';
import { Badge } from '../ui/badge';
/**
 * Quiet indicator that a meeting stream is configured to auto-start.
 */
export function MeetingAutoStartLabel(_a) {
    var className = _a.className;
    return (<Badge className={cn('py-0 text-[10px]', className)} title="Stream will auto-start" variant="info-alt2-outline">
      <Play aria-hidden="true" className="h-3 w-3"/>
      Auto-start
    </Badge>);
}
